import React, { useState } from "react";
import {
  FormFeedback,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import actions from "../../redux/actions";
import { showError } from "../../utilities/alerts/toastAlerts";
import validateInput from "../../utilities/validations/emptyValidator";
import Select from "react-select";
export default function CreateEditDiseaseCategory({
  modalVisible,
  toggleModal,
  onAddEditomplete,
  isEdit,
  diseaseCategoryData,
  editData = {},
}) {
  const [state, setState] = React.useState({
    name: "",
    code: "",
    ...editData,
  });
  const [selectedOption, setSelectedOption] = useState(null);
  console.log(editData, "th ei");
  const [errorObj, setErrorData] = useState({});
  const updateState = (data) => setState((val) => ({ ...val, ...data }));

  const onChangeText = (e) => {
    if (errorObj[e.target.name]) {
      setErrorData((data) => ({ ...data, [e.target.name]: "" }));
    }
    updateState({ [e.target.name]: e.target.value });
  };
  const onParamSelect = (data) => {
    console.log(data, "the data value");
    setSelectedOption(data);
  };

  const onSubmit = () => {
    let { isValid, errors } = validateInput({
      name: { value: state.name, name: "Name" },
      code: { value: state.code, name: "Code" },
    });

    console.log(errors, "the errors data value");
    if (!selectedOption) {
      isValid = false;
      errors.selectedOption = "Select disease category";
    }
    if (!isValid) {
      setErrorData(errors);
      return;
    } else {
      let apiData = {
        diseaseCategory: selectedOption.value+"",
        ...state,
      };
      actions
        .addEditDisease(apiData)
        .then((res) => {
          console.log(res, "the response value");
          onAddEditomplete();
        })
        .catch((error) => {
          console.log(error, "the error value");
          //   setIsLoading(false);
          showError(error);
        });
    }
  };

  console.log(errorObj, "the errA");
  console.log(state.code + "asd");
  return (
    <Modal centered isOpen={modalVisible} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>{`${
        isEdit ? "Edit" : "Add"
      } Disease`}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label>Name</label>
          <Input
            name={"name"}
            onChange={onChangeText}
            value={state.name}
            invalid={!!errorObj.name}
            type="text"
          />
          <FormFeedback>{errorObj.name}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <label>Category Code</label>
          <Input
            name={"code"}
            onChange={onChangeText}
            value={state.code}
            invalid={!!errorObj.code}
            // type="number"
          />
          <FormFeedback>{errorObj.code}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <label>Disease Category</label>
          <Select
            value={selectedOption}
            onChange={onParamSelect}
            options={diseaseCategoryData}
          />
          <p
            className={`invalid-feedback ${
              !!errorObj.selectedOption ? "error-text" : ""
            }`}
            valid={false}
          >
            {errorObj.selectedOption}
          </p>
        </FormGroup>

        <div
          className="create-btn"
          style={{ textDecoration: "none", width: 100, textAlign: "center" }}
          onClick={onSubmit}
        >
          Submit
        </div>
      </ModalBody>
    </Modal>
  );
}
